/**
 * javascript error trace
 */

window.onerror = function(message, url, file, lineNumber) {
	new Image().src = "/trace.gif?message="
	+ encodeURIComponent(message)
	+ "&url=" + encodeURIComponent(url)
	+ "&file=" + encodeURIComponent(file)
	+ "&lineNumber=" + encodeURIComponent(lineNumber);
};
